/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Tvpi1Inputs */

const en_coinvestments_report_tvpi1 = /** @type {(inputs: Coinvestments_Report_Tvpi1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TVPI`)
};

/**
* | output |
* | --- |
* | "TVPI" |
*
* @param {Coinvestments_Report_Tvpi1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_tvpi1 = /** @type {((inputs?: Coinvestments_Report_Tvpi1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Tvpi1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_tvpi1(inputs)
});
export { coinvestments_report_tvpi1 as "coInvestments_report_tvpi" }